<template>
  <div class="exhibition">
    <common-layout>
      <div slot="header">
        <h3>我的印章</h3>
      </div>
      <div class slot="container">
        <h2>印章信息</h2>
        <el-form ref="form" :model="form" label-width="80px" v-if="!isEdit" class="info_form">
          <el-form-item label="印章名称">
            <el-input v-model="form.stampName" disabled></el-input>
          </el-form-item>
          <el-form-item label="印章图片">
            <el-image
              style="width: 100px; height: 100px"
              :src="this.imgUrl + form.stampPicture"
              fit="contain"></el-image>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onEdit">修改</el-button>
          </el-form-item>
        </el-form>
        
        <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules" v-else class="edit_form">
          <el-form-item label="印章名称" prop="stampName" key="stampName">
            <el-input v-model="addForm.stampName"></el-input>
          </el-form-item>
          <el-form-item label="印章图片" class="line_wrap" prop="stampPicture">
            <div class="focus_txt" v-if="!addForm.stampPicture">
              <div>温馨提示：</div>
              <div>第①步：在空白白纸上盖上印章；</div>
              <div>第②步：上传扫描件；</div>
            </div>
            <el-upload
              class="upload-demo"
              drag
              :file-list="imgArr"
              accept=".png"
              :action="this.uploadURL"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="addForm.stampPicture" :src="this.imgUrl + addForm.stampPicture" class="img_border" />
              <i class="el-icon-upload" v-if="!addForm.stampPicture"></i>
              <div class="replace_btn">更换图片</div>
              <div class="el-upload__text" v-if="!addForm.stampPicture">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip" v-if="!addForm.stampPicture">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
            
          </el-form-item>
          <el-form-item>
            <div class="btns_wrap">
              <el-button type="primary" @click="onConfirm">确定</el-button>
              <el-button type="info" @click="cancel">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </common-layout>

    <!-- 裁剪图片弹窗 -->
    <el-dialog :title="title" :visible.sync="openDialog" width="800px" append-to-body @opened="modalOpened">
      <el-row>
        <el-col :xs="24" :md="12" :style="{height: '350px'}">
          <vue-cropper
            ref="cropper"
            :img="options.img"
            :info="true"
            outputType="png"
            style="background-image:none"
            :autoCrop="options.autoCrop"
            :autoCropWidth="options.autoCropWidth"
            :autoCropHeight="options.autoCropHeight"
            :canScale="options.canScale"
            :fixedBox="options.fixedBox"
            :canMove="options.canMove"
            :centerBox="options.centerBox"
            :original="options.original"
            @realTime="realTime"
          />
        </el-col>
        <el-col :xs="24" :md="12" :style="{height: '350px'}">
          <div class="avatar-upload-preview" :style="{'width': 350 + 'px', 'height': 350 + 'px',  'overflow': 'hidden', 'margin': '5px'}">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
        </el-col>
        <el-col :lg="{span: 2, offset: 6}" :md="2">
          <el-button type="primary" size="small" @click="uploadImg()">提 交</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from "../../components/common-layout.vue";

import { VueCropper }  from 'vue-cropper'
import HTTP from "../../../utils/http";
export default {
  components: {
    CommonLayout,
    VueCropper
  },
  data() {
    return {
      limit: 1,
      form: {
        stampName: '',
        stampPicture: '',
        stampType: 1
      },
      addForm: {
        stampName: '',
        stampPicture: '',
        stampType: 1
      },
      imgArr: [],
      isEdit: false,
      openDialog: false,
      options: {
        img: '', //裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 119, // 默认生成截图框宽度
        autoCropHeight: 119, // 默认生成截图框高度
        canScale: false, // 图片是否允许滚轮缩放
        canMove: false, // 上传图片是否可以移动
        centerBox: true, // 截图框是否被限制在图片里面
        original: true, // 上传图片按照原始比例渲染
        fixedBox: true // 固定截图框大小 不允许改变
      },
      previews: {},
      title: '图片裁剪',
      fileimg: '',
      fileData: null,
      isCreated: false,
      
      rules: {
        stampName: [
          { required: true, trigger: "blur", message: "请输入印章名称" }
        ],
        stampPicture: [{ required: true, message: "请上传印章图片" }]
      },
    };
  },
  created() {
    this.getStampData()
  },
  methods: {   
    getStampData() {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/signature/stamp/get`).then((res) => {
        if (res.code == 0) {
          console.log('res.data', res.data)
          if(res.data === null){
            this.isCreated = true
          }else{
            this.isCreated = false
            res.data.stampPicture = res.data.stampPicture
            this.form = res.data
          }
        }
      });
    },
    modalOpened() {

    },
    // 编辑头像
    editCropper(file) {
      console.log(file)
      this.openDialog = true;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {      
          let path = ''
          if(this.isCreated) {
            path = `${urlConfig.devUrl}apij2/admin-api/signature/stamp/create`
          }else{
            path = `${urlConfig.devUrl}apij2/admin-api/signature/stamp/update`
          }
          this.http.post(path, this.addForm).then((res) => {
            if (res.code == 0) {
              console.log('res.data', res.data)
              this.$message.success('修改成功')
              this.cancel()
              this.getStampData()
            }
          });
        }
      })
    },
    onEdit() {
      this.addForm = this.form
      this.isEdit = true
    },
    cancel() {
      this.imgArr = []
      this.getStampData()
      this.isEdit = false
    },
    // 实时预览
    realTime(data) {
      this.previews = data;
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },    
    // 上传图片
    uploadImg() {
      this.$refs.cropper.getCropBlob(data => {
        let formData = new FormData();

        let file = new File(
            [data], this.fileData.name, { type: data.type, lastModified: Date.now() }
        );
        
        formData.append("file", file);
      
        HTTP.axios({
          url: `${urlConfig.devUrl}apij2/admin-api/signature/stamp/rmBackground`,
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            "Admin-Token": 'Bearer test17'
          },
        })
          .then((res) => {
            this.imgArr.push({
              url: this.imgUrl + res.data.data
            })
            this.addForm.stampPicture = this.imgUrl + res.data.data
            console.log('this.form.stampPicture', this.form.stampPicture)
            console.log('this.imgArr', this.imgArr)
            this.openDialog = false;
          })
          .catch((error) => {

          });
      });
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    
    beforeAvatarUpload(file) {
      this.fileData = file
      let res = this.getType(file)
      console.log('file', file)
      if(res) {        
        let reader = new FileReader()
        // 转化为blob
        reader.readAsArrayBuffer(file);
        reader.onload = e => {
          console.log('e', e)
          let data;
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]));
          } else {
            data = e.target.result;
          }
          this.options.img = data;
          console.log()
        };
        // 转化为base64
        // reader.readAsDataURL(file)
        this.openDialog = true;
      }
      
    },
    getType(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;

    },
  },
};
</script>
<style lang="scss" scoped>
@include component(exhibition) {
  width: 100%;
  height: 100%;

  @include tweak(add-button) {
    @include component(el-form-item__content) {
      display: flex;
      justify-content: flex-start;
    }

    @include component(el-select) {
      width: 220px;
      margin-right: 15px;
    }
  }


  @include part(addBtn) {
    &:nth-child(2) {
      margin-right: 10px;
    }

    &:nth-child(1) {
      background: #623aa2 !important;
      color: #fff;
      border: none;
    }
  }
h2{
  text-align: left;
  padding: 10px 0 30px 10px;
}
.info_form{
  .el-button{
    display: block;
  }
}
.btns_wrap{
  display: flex;
  justify-content: flex-start;
}
.el-image{
  display: block;
}
/deep/.upload-demo{
  border: none;
  text-align: left;
 
}
.replace_btn{
  background-color: #00a1ff;
  color: #fff;
}
.focus_txt{
  text-align: left;
  color: #8c939d;
}
.el-input{
  display: block;
  width: 360px;
}
.el-upload__tip{
  text-align: left;
}
  @include part(table) {
    margin-top: 30px;
    width: 100%;
  }

  @include component(code-img) {
    display: inline-block;
    width: 80px;
    height: 80px;

    img {
      width: 100%;
      display: block;
    }
  }

  // @include component(avatar-uploader) {
  // 	width: 200px;
  // }
  @include component(el-form-item) {
  }

  @include part(item) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include component(el-radio-group) {
      width: 100%;
      text-align: left;
    }
  }

  @include component(row1) {
    width: 48%;
    display: flex;
    flex-direction: column;
  }

  @include component(row2) {
    width: 48%;
    display: inline-block;

    &:nth-child(2n) {
      margin-left: 2%;
    }
  }

  @include component(rowTime) {
    width: 100%;
  }

  @include component(rowLine) {
    display: inline-block;
    width: 50%;
  }

  @include component(el-select) {
    width: 100%;
  }

  @include part(map) {
    display: flex;
    justify-content: flex-start;

    @include component(el-radio-group) {
      width: 100%;
      text-align: left;
    }

    @include component(rowLink) {
      width: 30%;
    }

    .rowMap {
      width: 40%;

      &:nth-child(2) {
        width: 60%;

        @include component(el-form-item__content) {
          display: flex;
          justify-content: space-around;

          @include component(el-input) {
            width: 40%;
          }
        }
      }
    }

    .rowLon {
      width: 50%;
      display: inline-block;
    }
  }

  @include component(rowRegion) {
    width: 50%;
  }

  .pagination {
    margin-top: 10px;
    text-align: left;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 360px;
    display: block;
  }
  /deep/.el-upload-dragger{
    border: none;
    height: 100%;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }
  .hidden_wrap{
    display: none !important;
  }

  /deep/ .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
  /deep/.cell canvas {
    height: 65px;
  }

  .print {
    border-top: #e2e2e2 1px solid;
    height: 20px;
    position: fixed;
    bottom: 34px;
    width: 100%;
    left: 0;
    padding-top: 55px;
  }
  .ercode {
    /deep/.el-dialog__header {
      padding: 20px 32px 10px;
      font-weight: bold;
      background-color: #f2f3f5;
      font-size: 16px;
    }
  }
}
</style>
